<script lang="ts" setup>
  import { LogoText } from '../../../shared/ui/logo-text';
</script>

<template>
  <header id="songstar-header">
    <LogoText id="songstar-logo-text" text="Songstar" />
  </header>
</template>

<style scoped>
  #songstar-header {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100vw;
  }

  #songstar-logo-text {
    font-size: var(--font-size-2xl);
    text-align: center;
  }
</style>
